// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div id="toolbar-image">
    <v-toolbar class="transparent" dense :class="{'openedSearch': searchOpened}">
      <mobile-search v-if="!searchOpened" @click.native="openMobileSearch" ></mobile-search>
      <img class="tbtitle hidden-xs-only" id="stellarium-web-toolbar-logo" src="@/assets/images/sr_logo.svg" width="28" height="28" alt="Star Registration Logo"/>
      <span style="font-family: Proxima_Light" class="tbtitle hidden-sm-and-down logo-span"><b style="font-family: Proxima_Bold">STAR</b>REGISTRATION</span>
      <v-spacer v-if="!searchOpened"></v-spacer>
      <header-logo v-if="!searchOpened"></header-logo>
      <target-search :class="{'target-mobile': searchOpened}" v-if="searchOpened"></target-search>
      <target-search-desktop></target-search-desktop>
      <v-spacer v-if="!searchOpened"></v-spacer>
      <top-tooltip></top-tooltip>
      <div v-if="$store.state.showFPS" class="subheader grey--text hidden-sm-and-down pr-2" style="user-select: none;">FPS {{ $store.state.stel ? $store.state.stel.fps.toFixed(1) : '?' }}</div>
<!--      <gyroscope-button-->
<!--       class="top"-->
<!--       :label="$t('Rotation')"-->
<!--      ></gyroscope-button>-->
      <hamburger v-if="!searchOpened"></hamburger>
      <img v-if="searchOpened" class="close-button" @click="searchOpened = false" src="@/assets/images/ic_close.svg" width="10" height="10" alt="Close"/>
    </v-toolbar>
  </div>
</template>

<script>

import TargetSearch from '@/components/target-search'
import TargetSearchDesktop from '@/components/target-search-desktop'
import TopTooltip from '@/components/top-tooltip.vue'
import Hamburger from '@/components/hamburger'
import MobileSearch from '@/components/mobile-search'
import HeaderLogo from '@/components/header-logo'
import swh from '@/assets/sw_helpers.js'
// import GyroscopeButton from '@/components/gyroscope-button.vue'

export default {
  data: function () {
    return {
      searchOpened: false
    }
  },
  computed: {
    appVersion: function () {
      var version = swh.checkAppVersion()
      if (version) {
        return true
      } else {
        return false
      }
    },
    appMobile: function () {
      var app = swh.checkApp()
      if (app) {
        return true
      } else {
        return false
      }
    },
    fov: function () {
      if (!this.$store.state.stel) return '-'
      const fov = this.$store.state.stel.fov * 180 / Math.PI
      return fov.toPrecision(3) + '°'
    }
  },
  methods: {
    // check: function () {
    //   console.log(this.$refs.gyroscope)
    //   // this.$store.commit('updateGyroStatus', { key: 'gyroStatus', index: 1, value: true })
    //   // console.log(this.$store.commit('updateGyroStatus', { key: 'gyroStatus', index: 1, value: true }))
    // },
    toggleNavigationDrawer: function () {
      this.$store.commit('toggleBool', 'showNavigationDrawer')
    },
    openMobileSearch () {
      if (this.appMobile) {
        this.searchApp()
      } else {
        this.searchOpened = true
      }
    },
    searchApp: function () {
      if (this.appVersion) {
        window.MessageInvoker.postMessage(JSON.stringify({ type: 'search' }))
      } else {
        window.MessageInvoker.postMessage('search')
      }
    }
  },
  components: { TargetSearch, TopTooltip, Hamburger, MobileSearch, HeaderLogo, TargetSearchDesktop }
}
</script>

<style lang="scss">
header{
  .v-toolbar__content{
    @media screen and (min-width: 1050px){
      padding: 0px 50px;
    }
    @media screen and (min-width: 1300px){
      padding: 0 150px;
    }
  }
}
#toolbar-image {
  background: url("../assets/images/header.png") center;
  background-position-x: 55px;
  background-position-y: 0px;
  height: 80px;
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  @media screen and (max-width: 599px){
    height: 60px;
  }
  header{
    height: 80px !important;
    @media screen and (max-width: 599px){
      height: 60px !important;
    }
    .v-toolbar__content{
      height: 80px !important;
      @media screen and (max-width: 599px){
        height: 60px !important;
        padding: 0 20px;
      }
    }
  }
}

#stellarium-web-toolbar-logo {
  margin-right: 15px;
  @media screen and (max-width: 959px){
    margin-left: 30px;
  }
}

.tbtitle {
  font-size: 24px;
  line-height: 19px;
  user-select: none;
}
.logo-span{
  font-weight: 300;
}
.theme--dark.v-toolbar.v-sheet {
  background: rgba(16, 20, 32, 0.7) !important;
  backdrop-filter: blur(10px);
}
.openedSearch{
  .v-toolbar__content{
    justify-content: space-between;
  }
}
.target-mobile{
  max-width: 430px;
  width: 100%;
  padding-right: 15px;
  @media screen and (max-width: 499px){
    max-width: 390px;
  }
}
</style>
